import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery } from 'react-query';
import { UserDto } from '../types/index';
import { UserKeys } from './user.keys';

export const getUser = async (id: string) => {
  const response = await clients.admin.get(`/users/${id}`);
  return response.data as ApiResponse<UserDto>;
};

export const useGetUser = (id: string | undefined) => {
  const definiteUserId = id?.toString() ?? '';
  return useQuery(UserKeys.detail(definiteUserId), () => getUser(definiteUserId), {
    enabled: id !== undefined,
  });
};
